import { Theme } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { CSSProperties } from 'react';
import * as React from 'react';
import './DashboardCard.scss';

export interface IDashboardCardProps
  extends Omit<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'className'> {
  theme: Theme.DARK | Theme.LIGHT;
  showBlurredBackground: boolean;
  tabColor?: string;
  className?: string | object;
}

function DashboardCard(props: IDashboardCardProps) {
  const { className, children, theme, tabColor, style, showBlurredBackground, ...divProps } = props;

  const classes = classNames('dashboard-card', theme, className);

  const styles: CSSProperties = Object.assign(
    {},
    style,
    tabColor ? { borderTop: `5px solid ${tabColor}`, borderTopLeftRadius: 0, borderTopRightRadius: 0 } : {}
  );

  return (
    <div className={classes} {...divProps} style={styles}>
      {showBlurredBackground && <div className="blurred-background" />}
      {children}
    </div>
  );
}

DashboardCard.defaultProps = {
  showBlurredBackground: false,
};

export default DashboardCard;
